import { MatTreeFlattener, MatTreeFlatDataSource } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { DatePipe } from '@angular/common';
import { PageLoaderService } from './../../common/services/page-loader.service';
import { SharedService } from './../../common/services/shared-service';
import { CompanyManagementViewService } from './../../company-view/services/company-management-view.service';
import { CompanySideBarTreeViewService } from './../../company-view/services/company-side-bar-tree-view.service';
import { MatDialog } from '@angular/material/dialog';
import { Component, Input, OnInit, Output, SimpleChanges, ViewChild, EventEmitter } from '@angular/core';
import Utils from 'app/Utils';
import { ActivatedRoute } from '@angular/router';
interface CompanyNode {
  nombre: string;
  nivel: number;
  empresaId: number;
  activo: string;
  orden: string;
  padreId: number;
  finGestion : string;
  children?: CompanyNode[];

}
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
}
@Component({
    selector: 'app-staff-tree',
    templateUrl: './staff-tree.component.html',
    styleUrls: ['./staff-tree.component.scss'],
    standalone: false
})
export class StaffTreeComponent implements OnInit {

  // @ViewChild(CreateCompanyComponent) child;
  // @ViewChild(EmpresaComponent) appEmpresa: EmpresaComponent;
  @Input() loadTreeviewEmit:any;
  @Output() empresaIdEmit = new EventEmitter<any>();
  permissionList: Array<string>;
  currentUser: any[];
  currentUserAbreviacion: any;
  currentUserNombre: any;
  activeStatusTreeViewData: string = 'A';
  isStaffImportPage: boolean = false;
  searchString: string = '';
  treeData;
  newCompanyPadreId;
  selectedPadreId;
  empresaId;
  empresaChildCount;
  selectedCompanyName;
  permit47: number;
  permit2: number;
  permit7: number;
  permit32: number;
  permit13: number;
  activeInactivePermission = false;
  crearPermission = false;
  activarPermission = false;
  desactivarPermission = false;
  moverPermission = false;
  cerrarBajasPermission = false;
  bloquearPermission = false;
  eliminarDatosPermission = false;
  eliminarEmpresaPermission = false;
  createdCompanyId;
  activeNode;
  boolIsCreated: boolean = false;
  myDateTime :string ;
  testString;
  private transformer = (node: CompanyNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.nombre,
      id: node.empresaId,
      status: node.activo,
      padreid: node.padreId,
      level: level,
      finGestion:  this.datesCheck(this.datePipe.transform(node.finGestion, 'yyyy-MM-dd')),
    };
  }


  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
    this.transformer, node => node.level, node => node.expandable, node => node.children);

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  
  constructor(
    
    private _dialog: MatDialog,
    private _companySideBarTreeViewService: CompanySideBarTreeViewService,
    private _companyManagementViewService : CompanyManagementViewService,
    private _sharedService: SharedService,
    private _pageLoaderService: PageLoaderService,
    private datePipe: DatePipe,
    private route: ActivatedRoute 

  ) {

  }

  datesCheck(finGestion)
  {
    this.myDateTime=new Date().toDateString();
    this.myDateTime = this.datePipe.transform(this.myDateTime, 'yyyy-MM-dd');
    if(finGestion==null)
    {
      return false;
    }
    else
    {
      if(this.datePipe.transform(finGestion, 'yyyy-MM-dd') < this.myDateTime)
      {
        return true;
      }
      else
      {
        return false;
      }
    }
  }
  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  ngOnInit(): void {
    
    
    this.createdCompanyId = 0;
    this.GetTreeViewData(this.activeStatusTreeViewData, this.searchString);
    const currentRoute = this.route.snapshot.url.join('/');  // Obtén la ruta actual
    this.isStaffImportPage = currentRoute === 'staff-import';

    this.searchString = '';
    this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
    this.currentUserAbreviacion = this.currentUser['abreviacion'];
    this.currentUserNombre = this.currentUser['nombre'];
    this.permissionList = Utils.decrypt(localStorage.getItem('permissionIds')).split(',');
    this.permit47 = this.permissionList.indexOf('47');
    this.permit2 = this.permissionList.indexOf('2');
    this.permit7 = this.permissionList.indexOf('7');
    this.permit32 = this.permissionList.indexOf('32');
    this.permit13 = this.permissionList.indexOf('13');

    if (this.permit47 != -1) {
      this.activeInactivePermission = true;
    }

    this._companySideBarTreeViewService.createdCompanyName.subscribe(message => this.createdCompanyId = message)


  }
  ngOnChanges(changes: SimpleChanges){
    // if(this.loadTreeviewEmit)
    // {   
    //   // this._companySideBarTreeViewService.GetTreeView(this.activeStatusTreeView, this.searchString)
    //   // .subscribe(res => {
    //   //   this.treeData=res;
    //   //   this.dataSource.data = filterByEmpresa(this.treeData, this.loadTreeviewEmit.empresaId)
    //   //   this.treeControl.expandAll();
    //   // });
    //   this.GetTreeViewData(this.searchString);
    //   this.createdCompanyId=0;
    // }
    
  }

  nodeOperations(node) {
    
    //Set Crear Permission
    if (this.permit2 != -1 && node.status == "S") {
      this.crearPermission = true;
    }
    //Eliminar Company
    if (this.permit2 != -1 && node.status == "E") {
      this.crearPermission = false;
    }
    //Set Activar Permission
    if (this.permit7 != -1 && node.status == "N" && node.padreid != 0) {
      this.activarPermission = true;
      this.desactivarPermission = false;
    }
    //Set Desactivar Permission
    if (this.permit7 != -1 && node.status == "S" && node.padreid != 0) {
      this.desactivarPermission = true;
      this.activarPermission = false;
    }
    //Eliminar Company
    if (this.permit7 != -1 && node.status == "E" && node.padreid != 0) {
      this.desactivarPermission = true;
      this.activarPermission = false;
    }
    
    //Set Mover Permission
    if (this.permit32 != -1 && node.status == "S" && node.padreid != 0) {
      this.moverPermission = true;
    }else
    {
      this.moverPermission = false;
    }
    //Set Cerrar Bajas Permission
    if (this.permit13 != -1 && node.status == "S" && node.padreid != 0) {
      this.cerrarBajasPermission = true;
    }
    //Eliminar Company 
    if (this.permit13 != -1 && node.status == "E" && node.padreid != 0) {
      this.cerrarBajasPermission = true;
    }
    if(node.padreid == 0)
    {
      this.activarPermission = false;
      this.desactivarPermission = false;
      this.moverPermission = false;
      this.cerrarBajasPermission = false;
      this.bloquearPermission = false;
      this.eliminarDatosPermission = false;
      this.eliminarEmpresaPermission = false;
    }
    
    //Set Bloquar Permission,  Set Eliminar Datos Permission, Set Eliminar Empresa Permission,
    if (this.permit7 != -1 && node.padreid != 0) {
      this.bloquearPermission = true;
      this.eliminarDatosPermission = true;
      this.eliminarEmpresaPermission = true;
    }
    
    this.newCompanyPadreId = node.id;
    this.empresaId = node.id;
    this.selectedPadreId = node.padreId;
    this.GetChildCompanyCount(this.empresaId);
  }

  nodeOperationsLoadEmpresa(node) {
    //always request data for root company
    if(this._companySideBarTreeViewService.selectedCompany != node.id || node.id == 1)
    {    
      let obj={
        empresaId:node.id,
        empresa:node.name
      }
      this.empresaIdEmit.emit(obj)
    }
  }

  ResetTree(node)
  {
    if(this.createdCompanyId>0 && node.padreid==0)
    {
      this.GetTreeViewData(this.activeStatusTreeViewData, this.searchString);
      this.createdCompanyId=0;
      this.nodeOperationsLoadEmpresa(node)
    } 
  }

  filterTree(searchString: any) {
    this.dataSource.data = this.treeData.filter(employee => employee.nombre.indexOf(searchString) !== -1);
    this.dataSource.data = filter(this.treeData, searchString)
  }

  activeStatusChange(activeStatusTreeViewData: string) {    
    this.searchString = '';
    this.createdCompanyId=0;
    this.GetTreeViewData(activeStatusTreeViewData, this.searchString);   
    this.restCompanyProccess();   
  }

/*   activeStatusChange(activeStatusTreeView) {    
    this.searchString = '';
    this.createdCompanyId=0;
    this.GetTreeViewData(this.searchString);   
    this.restCompanyProccess();   
  }
 */
  searchCompany(searchString) {    
    if (searchString) {
     this.dataSource.data = filter(this.treeData, searchString.trim().toUpperCase())
      this.treeControl.expandAll();
      this.restCompanyProccess();
    } else {
      this.GetTreeViewData(this.activeStatusTreeViewData, this.searchString);
      this.createdCompanyId=0;
      this.restCompanyProccess();
    }
  }
   
  restCompanyProccess() {
    if(this.loadTreeviewEmit)
    {
      this._companySideBarTreeViewService.changecreatedCompanyName('')
      this._companySideBarTreeViewService.changeCompanyEmpresaId('0')
      this._companySideBarTreeViewService.changeCompanyEmpresaName('')
      this._companySideBarTreeViewService.sendClickUpdateEvent();
    }
    
  }


  private GetTreeViewData(activeStatus: string, searchString: any) {
    this._companySideBarTreeViewService.GetTreeViewStaff(activeStatus, searchString)
      .subscribe(res => {
        if(res[0].children.length != 0) {
          this.treeData = res;
          this.dataSource.data = this.treeData;
        }
        if (this.createdCompanyId > 0) {
          this.dataSource.data = filterByEmpresa(this.treeData, this.createdCompanyId);
          this.treeControl.expandAll();
          this._companySideBarTreeViewService.changeCompanyEmpresaId('0');
        } else {
          if(this.treeData == undefined){
            this.treeData = res;
            this.dataSource.data = this.treeData;
          }else{
            this.dataSource.data = this.treeData;         
          }      
        }
      });
}

  private GetChildCompanyCount(empresaid: any) {
    this._companySideBarTreeViewService.CheckCompanyChildren(empresaid)
      .subscribe(res => {
        if (res.result > 0) {
          this.empresaChildCount = res.result;
        }
        else {
          this.empresaChildCount = 0;
        }
      });
  }

 

  
}

function filter(array, text) {
  const getNodes = (result, object) => {
    if (object.nombre.match(text)) {
      result.push(object);
      return result;
    }
    if (Array.isArray(object.children)) {
      const children = object.children.reduce(getNodes, []);
      if (children.length) result.push({ ...object, children });
    }
    return result;
  };

  return array.reduce(getNodes, []);
}
function filterByEmpresa(array, text) {
  const getNodes = (result, object) => {
    if (object.empresaId === text) {
      result.push(object);
      return result;
    }
    if (Array.isArray(object.children)) {
      const children = object.children.reduce(getNodes, []);
      if (children.length) result.push({ ...object, children });
    }
    return result;
  };

  return array.reduce(getNodes, []);
}